import { Flex, Row, Col, Section, Typography } from 'components';
import useRecommendations from 'features/recommendations/useRecommendations';
import { useSchool } from 'features/school';
import React from 'react';
import { useParams } from 'react-router-dom';
import { RecommendationsCard } from '..';

// import { Container } from './styles';

interface ListProps {
  productClassUuid: string;
}

const List = ({ productClassUuid }: ListProps) => {
  const { productSlug } = useParams();
  const { recommendations } = useRecommendations();
  const { schoolUuid } = useSchool();

  // const isBenndorf = schoolUuid === 'cfaf550b-037d-45b2-9f84-979fb01185d4';
  // const isG10 = schoolUuid === '14d970bd-3794-4268-bf67-2c5d2d0f0285';
  const isMeuPlanoCrypto = schoolUuid === '20b929ad-c773-46e2-93de-991988587835';

  let title = 'Ativos recomendados';

  if (isMeuPlanoCrypto) {
    title = 'Lives e Análises';
  }

  return recommendations?.length ? (
    <Flex bg="white" py={{ d: 80, t: 60, m: 40 }}>
      <Section flexDirection="column">
        <Flex justifyContent="space-between" flexWrap={{ m: 'wrap', d: 'nowrap' }} alignItems="flex-end" flexGrow={0} mb={{ m: 3, d: 4 }}>
          <Flex flexDirection="column" flexGrow={0}>
            {/* <Typography type="type3" color="dark_350" upper mb={2}>
              Últimas recomendações
            </Typography> */}

            <Typography type="type8" fontWeight="bold" color="dark_350">
              {title}
            </Typography>
          </Flex>

          {/* <Flex flexGrow={0} mt={{ m: 2, t: 0 }}>
            <Link to={createUrl('reportsList')}>
              <Button height={{ m: 40 }}>Ver todos</Button>
            </Link>
          </Flex> */}
        </Flex>

        <Row gutter={20}>
          {recommendations.map((recommendation, index) => (
            <Col key={`report-item-${index.toString()}`} width={{ m: 1, t: 1 / 2, d: 1 / 4 }} mb={20}>
              <RecommendationsCard recommendation={recommendation} productSlug={productSlug} productClassUuid={productClassUuid} />
            </Col>
          ))}
        </Row>
      </Section>
    </Flex>
  ) : (
    <></>
  );
};

export default List;
